import React from 'react'

interface YouTubePlayerProps {
  videoId: string
}

const YouTubePlayer: React.FC<YouTubePlayerProps> = props => {
  const { videoId } = props
  return (
    <iframe
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
      allow="autoplay"
      width="100%"
      height={200}
      frameBorder="0"
    />
  )
}

export default YouTubePlayer
